import React from "react";
import TlkTable from "../../tlelrik/table/tlkTable";
import services from "../../../services";
import queryString from "query-string";
import moment from "moment";
import AcceptMovement from "../AcceptMovement";
import CreateDAA from "../CreateDAA";
import CreateIntroduzirRef from "../CreateIntroduzirRef";

const groupfield = [

    // { field: "Ano" },
    // { field: "Mês" },
    // { field: "Tipo de Movimento" },
    //{ field: "Entreposto" },
    // { field: 'Concelho' },
    // { field: 'Freguesia' },
];

const columnKeyMap = {
    //instalacaoVinica: "Instalação Vinica",
    produto: "Produto",
    tipoConta: "Tipo de Conta",
    nivelConta: "Nível Conta",
    estado: "Estado",
    cor: "Cor",
    anoProduto: "Ano",
    numeroRegisto: "Registo",
    tipoMovimento: "Tipo de Movimento",
    operacao: "Operação",
    saldoCativo: "Saldo Cativo",
    saldo: "Quantidade (Litros)",
    dataOperacao: "Data Mov.",
    estadoMovimento: "Situação",
};
const dateFormat = "DD-MM-YYYY HH:mm:ss";
const actionbuttons = { CommonRedirection: "Mov Aceitar", FillTransport: "Preencher Documento" , IntroduzirRef: "Introduzir referência do eDA" };

const filterValue = {
    Concelho: null,
    DataCriadoEnd: null,
    DataCriadoStart: null,
    DataModificadoEnd: null,
    DataModificadoStart: null,
    Designacao: null,
    Distrito: null,
    Estado: null,
    Fregusia: null,
    Geocod: null,
    NomeEntreposto: null,
    NumInstalacao: null,
    TipoInstalacao: null,
    nome: null,
    numero: null,
    entityId: null,
};

class UltMovsTab extends React.Component {
    constructor() {
        super();

        this.state = {
            loaded: false,
            data: [],
            popUpForm: '',
            totalCount: 0,
            columnList: [],
            filters: {
                Filters: filterValue,
                FiltersIn: null,
                FiltersLike: null,
                SortBy: "",
                IsSortTypeDESC: true,
                IsPagination: false,
                Page: 2,
                PageSize: 2,
            },
        };
    }

    componentDidMount() {
        (async () => {
            const queryParams = queryString.parse(this.props.location.search);
            const filters = {
                idEntidade: queryParams.entityId,
                idInstalacaoVinica: queryParams.IDInstalacaoVinica
            };
            this.setState({
                nif: queryParams.nif,
            });
            const response = await services.apiCall.requestApi(
                "ContaCorrente/ViewUltimosMovimentos",
                filters,
                "get"
            );
            // const columnList = Object.keys(columnKeyMap).map((key) => ({
            //     field: columnKeyMap[key],
            //     columnMenuType: "checkbox",
            // }));

            var columnList = [];

            Object.keys(columnKeyMap).forEach(e => {
                if(e === "anoProduto" || e === "numeroRegisto" || e === "saldo"){
                    columnList.push({field: columnKeyMap[e], columnMenuType: "number"});
                }
                else{
                    columnList.push({field: columnKeyMap[e], columnMenuType: "checkbox"});
                }
            });

            if (response) {
                const data = response.map((entity, index) => ({
                    ...entity,
                    ...Object.keys(columnKeyMap).map((key) => {
                        if (
                            key === "saldo"
                        ) {
                            entity[columnKeyMap[key]] = services.money.format(entity[key]) || "0";
                        }
                        else if (key === "dataOperacao"){
                            entity[columnKeyMap[key]] = moment(
                                entity.dataOperacao
                            ).format(dateFormat)
                        }
                        else {
                            entity[columnKeyMap[key]] = entity[key] || "NA";
                        }
                    }),
                    selected: false,
                }));
                window.localStorage.setItem('table_total', response.length);
                this.setState(() => ({
                    data,
                    columnList,
                    totalCount: window.localStorage.getItem("table_total"),
                    loaded: true,
                }));
            } else {
                this.setState(() => ({
                    data: response,
                    totalCount: 0,
                    columnList,
                    loaded: false,
                }));
            }
        })();
    }

    selectionChange(selection) {
        const data = [...this.state.data].map((item) => {
            if (
                selection.dataItem.codInstalacaoVinica ===
                item.codInstalacaoVinica
            ) {
                // TODO: Ask @Dart for the unique key to use here
                return { ...item, selected: true };
            } else {
                return { ...item, selected: false };
            }
        });
        this.setState({ data }, async () => {
            const queryParams = queryString.stringify({
                ...queryString.parse(this.props.location.search),
                installationId: 0,
            });
            this.props.history.push(
                `/conta_corrente/accounts_view?${queryParams}`
            );
        });
    }

    // ActionPerform = async (action, row) => {
    //     // if (action === "Detalhes da Conta") {
    //     //     const queryParams = queryString.stringify({
    //     //         entityId: row.codEntidade,
    //     //         IDInstalacaoVinica: parseInt(row.idInstalacaoVinica),
    //     //         nif: this.state.nif,
    //     //     });
    //     //     this.props.history.push(
    //     //         `/conta_corrente/tabs_view/account?${queryParams}`
    //     //     );
    //     // }
    // };
    ActionPerform = async (action, row) => {
        if (action === "acceptMovement") {
            this.setState({
                popUpForm: ""
            })
            console.log(row);
            console.log(row["Quantidade (Litros)"]);
            const params = queryString.parse(this.props.location.search);
            let popUpForm = (
                <AcceptMovement
                    //instalacaoVinica={this.state.entityDetail.wineInhalation}
                    tipoConta={params.tdc}
                    produto={params.pr}
                    quantidade={row["Quantidade (Litros)"]}
                    tipoMovimento={row["Tipo de Movimento"]}
                    entidade={row["Entidade Destino"]}
                    idContaCorrente={params.accountId}
                    qtdNum={row.valorOperacao}
                    idTipoMovimento={row.idTipoMovimento}
                    idContaCorrenteMovimento={row.idContaCorrenteMovimento}
                />
            )
            this.setState({
                popUpForm
            })
        }
        else if (action === "fillTransport") {
            this.setState({
                popUpForm: ""
            })
            console.log(row);
            console.log(row["Quantidade (Litros)"]);
            const params = queryString.parse(this.props.location.search);
            let popUpForm = (
                <CreateDAA
                    //instalacaoVinica={this.state.entityDetail.wineInhalation}
                    tipoConta={params.tdc}
                    produto={params.pr}
                    quantidade={row["Quantidade (Litros)"]}
                    tipoMovimento={row["Tipo de Movimento"]}
                    entidade={row["Entidade Destino"]}
                    idContaCorrente={params.accountId}
                    qtdNum={row.valorOperacao}
                    idTipoMovimento={row.idTipoMovimento}
                    idContaCorrenteMovimento={row.idContaCorrenteMovimento}
                />
            )
            this.setState({
                popUpForm
            })
        }
        else if (action === "IntroduzirRef") {
            this.setState({
                popUpForm: ""
            })
            const params = queryString.parse(this.props.location.search);
            let popUpForm = (
                <CreateIntroduzirRef
                    tipoConta={params.tdc}
                    produto={params.pr}
                    quantidade={row["Quantidade (Litros)"]}
                    tipoMovimento={row["Tipo de Movimento"]}
                    entidade={row["Entidade Destino"]}
                    idContaCorrente={params.accountId}
                    qtdNum={row.valorOperacao}
                    idTipoMovimento={row.idTipoMovimento}
                    idContaCorrenteMovimento={row.idContaCorrenteMovimento}
                />
            )
            this.setState({
                popUpForm
            })
        }
    };
    render() {
        return (
            <>
                <div className="mt-4">
                    <div className="table-section custom-k-grid pt-3">
                        <div className="table-responsive">
                            {this.state.loaded && (
                                <>
                                    <span>
                                        A pesquisa retornou{" "}
                                        {this.state.totalCount} registos
                                    </span>
                                    <TlkTable
                                        date={new Date()}
                                        list={this.state.data}
                                        modulename={"Conta Corrente"}
                                        //notAction={true}
                                        //viewFor="conta_movimento"
                                        // notGroup={true}
                                        //collepsview={true}
                                        columnlist={this.state.columnList}
                                        actionbuttons={actionbuttons}
                                        ActionPerform={(action, id) =>
                                            this.ActionPerform(action, id)
                                        }
                                        //fixTableWidth={true}
                                        groupfield={groupfield}
                                        //toolbarHTML={ this.getToolbarHtml() }
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div className="modal left-popup" id="accept-mov-left-popup">
                    <div className="modal-dialog modal-sm">
                        {
                            this.state.popUpForm
                        }
                    </div>
                </div>
            </>
        );
    }
    // render() {
    //     return (
    //         <>
    //             {
    //                 <>
    //                     <span>
    //                         A pesquisa retornou {this.state.totalCount} registos
    //                     </span>
    //                     <TlkTable
    //                         date={new Date()}
    //                         list={this.state.data}
    //                         modulename={"Conta Corrente"}
    //                         groupfield={groupfield}
    //                         actionbuttons={actionbuttons}
    //                         columnlist={this.state.columnList}
    //                         // ActionPerform={(action, id) =>
    //                         //     this.ActionPerform(action, id)
    //                         // }
    //                         toolbarHTML="Últimos movimentos das Contas Corrente ativas da Instalação"
    //                     />
    //                 </>
    //             }
    //             <div className="modal left-popup" id="accept-mov-left-popup">
    //                 <div className="modal-dialog modal-sm">
    //                     {
    //                         this.state.popUpForm
    //                     }
    //                 </div>
    //             </div>
    //         </>
    //     );
    // }
}

export default UltMovsTab;
